// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerFlex {
  display: flex;
}

.childflex {
  min-width: 400px;
  max-width: 300px;
  flex-basis: 300px;
}

.invoice-title {
  background: var(--button-a-background);
  color: var(--button-a-text);
  padding: 10px;
  border-radius: 20px;
  text-align: center;
  margin: 10px;
  margin-bottom: 10px;
}

.item-size ion-item {
  --min-height: 40px;
}

.order-item-box {
  --padding-end: 0px;
  --inner-padding-end: 0px;
}

.status-box {
  padding: 0;
  width: 40%;
  margin: auto;
  color: #fff;
}

.status-box.margin-bottom {
  margin-bottom: 3px;
}

.price {
  text-align: end;
  font-size: 14px;
}

.text-box {
  font-size: 14px;
}
.text-box ion-badge {
  --background: var(--button-b-background);
  color: var(--button-b-text);
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  align-items: flex-start;
  gap: 5px;
}

.code-text {
  color: #8a8c8e;
  font-size: 14px;
  padding-right: 10px;
}

.amount-col {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.amount-box {
  font-size: 12px;
  text-align: start;
  direction: ltr;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.amount-box .units {
  margin: 0 2px;
  direction: rtl;
  display: inline-block;
  text-align: end;
}
.amount-box .units span {
  margin: 0 2px;
}

ion-item-group ion-item.details-item {
  --min-height: 35px;
}
ion-item-group ion-label.field-label {
  max-width: 35%;
  min-width: 35%;
  margin: 0;
}

.details-size {
  width: 65%;
}

.vert-box {
  max-height: 56px;
  text-align: center;
}

.invoice-box {
  background: var(--button-b-background);
  color: var(--button-b-text);
  padding: 10px;
  border-radius: 20px;
  margin: 5px 0;
}

ion-item-divider {
  background: var(--main-top);
  color: var(--main-top-text);
  border-radius: 20px;
  margin: 5px 0;
}

ion-list.circle-list {
  padding: 0;
}

.props-box {
  font-size: 13px;
}

ion-badge.ion-color.ion-color-warning {
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/order/components/order-content/order-content.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EAEE,gBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAIA;EACE,sCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAKE;EACE,kBAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,eAAA;AAHF;;AAOA;EACE,eAAA;AAJF;AAOE;EACE,wCAAA;EACA,2BAAA;EAEA,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,uBAAA;EACA,QAAA;AANJ;;AAUA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAPF;;AAUA;EAEE,aAAA;EACA,8BAAA;EACA,sBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,6BAAA;AATF;AAYE;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAVJ;AAYI;EACE,aAAA;AAVN;;AAgBE;EACE,kBAAA;AAbJ;AAgBE;EACE,cAAA;EACA,cAAA;EACA,SAAA;AAdJ;;AAkBA;EACE,UAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,sCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AAfF;;AAmBA;EACE,UAAA;AAhBF;;AAyBA;EACE,eAAA;AAtBF;;AA0BA;EACI,cAAA;AAvBJ","sourcesContent":[".containerFlex {\n  display: flex;\n}\n\n.childflex {\n\n  min-width: 400px;\n  max-width: 300px;\n  flex-basis: 300px;\n}\n\n\n.invoice-title {\n  background: var(--button-a-background);\n  color: var(--button-a-text);\n  padding: 10px;\n  border-radius: 20px;\n  text-align: center;\n  margin: 10px;\n  margin-bottom: 10px;\n}\n\n.item-size {\n  ion-item {\n    --min-height: 40px;\n  }\n}\n\n.order-item-box {\n  --padding-end: 0px;\n  --inner-padding-end: 0px;\n}\n\n.status-box {\n  padding: 0;\n  width: 40%;\n  margin: auto;\n  color: #fff;\n}\n\n.status-box.margin-bottom {\n  margin-bottom: 3px;\n}\n\n.price {\n  text-align: end;\n  font-size: 14px;\n  //margin-top: 5px;\n}\n\n.text-box {\n  font-size: 14px;\n  //padding-right: 10px;\n\n  ion-badge {\n    --background: var(--button-b-background);\n    color: var(--button-b-text);\n\n    display: flex;\n    width: fit-content;\n    align-items: flex-start;\n    gap: 5px;\n  }\n}\n\n.code-text {\n  color: #8a8c8e;\n  font-size: 14px;\n  padding-right: 10px;\n}\n\n.amount-col {\n\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n}\n\n.amount-box {\n  font-size: 12px;\n  text-align: start;\n  direction: ltr;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n\n\n  .units {\n    margin: 0 2px;\n    direction: rtl;\n    display: inline-block;\n    text-align: end;\n\n    span {\n      margin: 0 2px;\n    }\n  }\n}\n\nion-item-group {\n  ion-item.details-item {\n    --min-height: 35px;\n  }\n\n  ion-label.field-label {\n    max-width: 35%;\n    min-width: 35%;\n    margin: 0;\n  }\n}\n\n.details-size {\n  width: 65%;\n}\n\n.vert-box {\n  max-height: 56px;\n  text-align: center;\n}\n\n.invoice-box {\n  background: var(--button-b-background);\n  color: var(--button-b-text);\n  padding: 10px;\n  border-radius: 20px;\n  margin: 5px 0;\n}\n\nion-item-divider {\n  background: var(--main-top);\n  color: var(--main-top-text);\n  border-radius: 20px;\n  margin: 5px 0;\n\n}\n\nion-list.circle-list {\n  padding: 0;\n}\n\nion-item-group {\n  ion-label {\n    //max-width: 50%;\n  }\n}\n\n.props-box {\n  font-size: 13px;\n}\n\n\nion-badge.ion-color.ion-color-warning {\n    color: inherit;\n}\n\n//\n//ion-badge {\n//  --background: var(--button-a-background);\n//  --color: var(--button-a-text);\n//}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
